module.exports = __webpack_public_path__ + "static/media/SunNUS2020.e0bc2b6c.jpeg";